import React, { Fragment, useState, useEffect, useCallback } from "react";

import { DataGrid, GridRowModes, useGridApiRef  } from '@mui/x-data-grid';
import { frFR as dataGridfrFR } from '@mui/x-data-grid/locales';

import Container from '@mui/material/Container';
import Box from '@mui/material/Box';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import IconButton from '@mui/material/IconButton';
import { red, common, blue } from '@mui/material/colors';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';

import { useAuth } from '#utils/auth';
import { TitlePage } from "#components/TitlePage";
import { TextError, TextTip } from '#components/TextInformation';
import { useApiResourceDefinition } from "#services/apiResourceDefinition";
import { useApiFamilyResource } from "#services/apiFamilyResource";
import ScrollButtonToTop from '#components/ScrollButtonToTop';
//import useFunctions from '#utils/functions';

export function Resources() {

    const { user } = useAuth();
    const api = useApiResourceDefinition();
    const apiFar = useApiFamilyResource();
    const [farList, setFarList] = useState({});

    // chargement famille resources pour edition
    useEffect(() => {       
        apiFar.getData()
            .then((json) => {
                if (json.returnCode === 0) {
                    if (json.returnDataCount>0) {
                        // on crée les tableaux pour le combo
                        let tempList = {};
                        tempList[0]=[];
                        json.returnData.map((r) => {
                            tempList[0].push({
                                value : r.far_id,
                                label : r.far_lib
                            });
                        });
                        setFarList(tempList);
                    }
                } 
            });

    }, [user]);

    //const { formatDatetime } = useFunctions();

    const [errorMessage, setErrorMessage] = useState("")

    const [activeTab, setActiveTab] = useState(0);
    const [isWorking, setIsWorking] = useState(false);


    // edit une ressource -----------------------------------------------------------
    const [rowModesModel, setRowModesModel] = React.useState({});
    const apiRef = useGridApiRef();

    const handleEditClick = (row, event) => {
        setRowModesModel({ ...rowModesModel, [row.red_id]: { mode: GridRowModes.Edit } });
        apiRef.current.startCellEditMode({id : row.red_id, field : 'red_lib' });
    };

    const handleSaveClick = (row, event) => {
        setRowModesModel({ ...rowModesModel, [row.red_id]: { mode: GridRowModes.View } });
    };    

    const handleCancelClick = (row, event) => {
        setRowModesModel({ ...rowModesModel, [row.red_id]: { mode: GridRowModes.View } });
    };        

    // row update
    const handleProcessRowUpdate = useCallback( 
        async  (updatedRow, originalRow) => {
//            console.log(updatedRow, originalRow);
            setIsWorking(true);
            const response = await api.updateData(updatedRow)
            setIsWorking(false);
            if (response.returnCode===0) {
                return updatedRow        
            } else {
                // TODO : Afficher message erreur
                return originalRow        
            }            
        }
        , []
    );

    const handleProcessRowUpdateError = (errors) => {
        console.log(errors);
    }

    //--------------------------------------------------------------
    // définition des listes 

    const refCodeTabs = [
        { code: 'inuse', lib: "Actif", comment: "Bureaux pouvant être réservés." }
        , { code: 'notinuse', lib: "Non réservables.", comment: "Bureaux ne pouvant pas être réservés." }
    ]

    const baseColumns = [
        { field: 'red_id', headerName: 'N°', width: 70, type: 'number' },
        { field: 'red_lib', headerName: 'Nom', width: 300, sortable : true, editable : true },                
        { field: 'red_is_active', headerName: 'Réservable', type: 'boolean', width: 90, editable : true },        
        { field: 'red_far_id', headerName: 'Type bureau',  width: 200, editable : true, 
            type: 'singleSelect',
            valueOptions : ({row})=> {
                return farList[0] || [{
                    value : 0,
                    label : ' '
                }]; 
            }    
        },        
        { field: 'actions',             
            type : 'actions', //disableColumnMenu: true, resizable: false, filterable: false, sortable: false, editable: false, groupable: false, 
            headerName: 'Actions',
            width: 90, headerAlign: 'center', align: 'center',            
            renderCell: (params) => {
                const isInEditMode = rowModesModel[params.row.red_id]?.mode === GridRowModes.Edit;
                if (isInEditMode) {
                    return (
                        <Box>
                            <IconButton sx={{ ml: 0, px: 0, py: 2, my: 0 }} onClick={(e) => handleSaveClick(params.row, e)} >
                                <SaveIcon sx={{ color: common[900]}}/> 
                            </IconButton>

                            <IconButton sx={{ ml: 0, px: 0, py: 2, my: 0 }} onClick={(e) => handleCancelClick(params.row, e)} >
                                <CancelIcon sx={{ color: red[500] }} />
                            </IconButton>
                        </Box>
                    )
                }
                return (
                    <Box>
                        <IconButton sx={{ ml: 0, px: 0, py: 2, my: 0 }} onClick={(e) => handleEditClick(params.row, e)} >
                            <EditIcon sx={{ color: common[900]}}/> 
                        </IconButton>
                    </Box>
                );
            }
        }    
    ].map(
        // valeur commune      
        (col) => {
            col.headerClassName = 'app-theme--header';
            col.editable = col.editable || false;  
            col.sortable = col.sortable || false;  // pb disableColumnSorting, on doit l'indiquer pour chaque column !      
            return col;
        }
    );

    // fonction pour init selon les tabs !
    const initFromTabs = (initValue) => {
        let arrayTabs = refCodeTabs.map((x) => x.code);
        let r = {};
        arrayTabs.forEach((tab) => { r[tab] = initValue; });
        return r;
    };

    const columns = initFromTabs(baseColumns);

    //--------------------------------------------------------------            
    const [isTabLoaded, setIsTabLoaded] = useState(initFromTabs(false));
    const [data, setData] = useState(initFromTabs({}));

    //--------------------------------------------------------------        
    const [paginationModel, setPaginationModel] = useState(initFromTabs({
        page: 0,
        pageSize: 25
    }));
    const [filterModel, setFilterModel] = useState(initFromTabs({
        items: []
    }));
    const [sortModel, setSortModel] = useState(initFromTabs(
        [{ field: 're_id', sort: 'asc' }]
    ));

    const [rowCount, setRowCount] = useState(initFromTabs(0));

    const onPaginationModelChange = (newPaginationModel) => {
        let keyTab = refCodeTabs[activeTab].code;
        let temp = { ...paginationModel };
        temp[keyTab] = newPaginationModel;
        setPaginationModel(temp);
    };

    const onFilterModelChange = (newFilterModel) => {
        let keyTab = refCodeTabs[activeTab].code;
        let temp = { ...filterModel };
        temp[keyTab] = newFilterModel;
        setFilterModel(temp);
    };

    const onSortModelChange = (newSortModel) => {
        let keyTab = refCodeTabs[activeTab].code;
        let temp = { ...sortModel };
        temp[keyTab] = newSortModel;
        setSortModel(temp);
    };

    //--------------------------------------------------------------    
    const handleChangeTab = (event, newValue) => {
        setActiveTab(newValue);
    };

    const getRowId = (data) => {
        return data.red_id;
    }

    useEffect(() => {
        let keyTab = refCodeTabs[activeTab].code;

        if (user) { // && !isTabLoaded[keyTab]) { 
            setIsWorking(true);
            api.getData(keyTab, paginationModel[keyTab], filterModel[keyTab], sortModel[keyTab])
                .then((json) => {
                    setIsWorking(false);
                    let tempL = { ...isTabLoaded };
                    let tempD = { ...data };
                    let tempRC = { ...rowCount }
                    tempL[keyTab] = true;
                    if (json.returnCode === 0) {
                        tempD[keyTab] = json.returnData;
                        tempRC[keyTab] = json.returnTotalDataCount;
                        setErrorMessage('');
                    } else {
                        tempD[keyTab] = {};
                        tempRC[keyTab] = 0;
                        setErrorMessage(json.returnMsg || 'Aucun bureau');
                    }
                    setData(tempD);
                    setRowCount(tempRC);
                    setIsTabLoaded(tempL);
                });
        }

    }, [user, activeTab, paginationModel, filterModel, sortModel]);

    //--------------------------------------------------------------        
    const getData = (tabId) => {
        let key = refCodeTabs[tabId].code;
        return (data[key] && data[key].length > 0) ? data[key] : null;
    }
    const getCol = (tabId) => {
        let key = refCodeTabs[tabId].code;
        return (columns[key] && columns[key].length > 0) ? columns[key] : null;
    }
    const getCommentActiveTab = (tabId) => {
        let key = refCodeTabs[tabId].comment;
        return key ? key : '';
    }
    const getRowCountActiveTab = (tabId) => {
        let key = refCodeTabs[tabId].code;
        return rowCount[key];
    }
    const getPaginationModelActiveTab = (tabId) => {
        let key = refCodeTabs[tabId].code;
        return paginationModel[key];
    }
    const getFilterModelActiveTab = (tabId) => {
        let key = refCodeTabs[tabId].code;
        return filterModel[key];
    }
    const getSortModelActiveTab = (tabId) => {
        let key = refCodeTabs[tabId].code;
        return sortModel[key];
    }

    const CustomNoRowsOverlay = () => {
        return <Box sx={{ pt: 5, width : '100%', textAlign : 'center' }}>Aucun bureau</Box>
    }




    return (
        <Fragment>
            <TitlePage titlePage="Bureaux" />

            {errorMessage !== '' && <TextError>{errorMessage}</TextError>}

            <Container maxWidth='xl' sx={{ pt: 2, pb: 4}} >
                {/* les tabs  */}
                <Box sx={{ mb: 2, py: 0, px: 0, borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={activeTab} onChange={handleChangeTab} variant="scrollable" scrollButtons="auto">
                        {
                            refCodeTabs.map((value, index) => (
                                <Tab key={index} label={value.lib} wrapped={true} />
                            ))
                        }
                    </Tabs>
                </Box>
                <TextTip>{getCommentActiveTab(activeTab)}</TextTip>

                {/* les datas */}
                <DataGrid        
                    width = '100%'            
                    localeText={dataGridfrFR.components.MuiDataGrid.defaultProps.localeText}
                    sx={getRowCountActiveTab(activeTab)>0 ? {minHeight:200}: {height:200}} //  important pour afficher l'overlay                        
                    slots={{ 
                        noRowsOverlay: CustomNoRowsOverlay,
                    }}
                    density='compact'
                    disableColumnSelector={true}

                    rowModesModel={rowModesModel}
                    //onRowModesModelChange={handleRowModesModelChange}
                    //onRowEditStop={handleRowEditStop}

                    apiRef={apiRef}
                    editMode='row'  
                    processRowUpdate={handleProcessRowUpdate} 
                    onProcessRowUpdateError={handleProcessRowUpdateError}

                    loading={isWorking}
                    getRowId={getRowId}
                    rows={getData(activeTab) || []}
                    rowCount={getRowCountActiveTab(activeTab)}
                    columns={getCol(activeTab)}

                    filterMode="server"
                    onFilterModelChange={onFilterModelChange}
                    filterModel = {getFilterModelActiveTab(activeTab)}

                    sortingMode="server"
                    onSortModelChange={onSortModelChange}
                    sortModel = {getSortModelActiveTab(activeTab)}

                    paginationMode="server"
                    pageSizeOptions={[10, 25, 50, 100]}
                    paginationModel={getPaginationModelActiveTab(activeTab)}
                    onPaginationModelChange={onPaginationModelChange}
                />
            </Container>

            <ScrollButtonToTop />

        </Fragment>
    );    
};